import React from 'react'
import { useTranslation } from 'react-i18next'
import { Indicator } from 'is24-corecss'
import { AttachmentDataWithRequiredAttachment } from '../../../../../../../../../../@types/types'

interface TitleIndicatorProps {
  attachment: AttachmentDataWithRequiredAttachment
}

export const TitleIndicator: React.FC<TitleIndicatorProps> = ({ attachment }) => {
  const { t } = useTranslation()

  if (!attachment?.attachment) {
    return null
  }

  // Use the same logic as in MultimediaDetailsModalContent
  const isFloorPlan = !!attachment.attachment.floorplan
  const floorPlanTitle = t('wizard.screen.multimedia.floorplan')
  const currentAttachmentTitle = isFloorPlan ? floorPlanTitle : attachment.attachment.title

  if (!currentAttachmentTitle) {
    return null
  }

  return (
    <Indicator.Root
      appearance='label'
      color='white'
      variant='flat'
      className='font-ellipsis'
      style={{ maxWidth: '200px' }}
    >
      {currentAttachmentTitle}
    </Indicator.Root>
  )
}
